<app-flows [display]="'by-actions'"></app-flows>
